import { useContext } from 'react';
import { SessionContext } from '../Components/Context/SessionContext';
import { UnidentifiedUserLocatario } from '../pages/Global/UnidentifiedUserLocatario';


export default function UserIdAuthorized({ children }) {
    const { session } = useContext(SessionContext);
    if (session.idUsuarioLocatario != 0 || localStorage.getItem('idLocatario')) return <>{children}</>;
    return <UnidentifiedUserLocatario></UnidentifiedUserLocatario>;
}